import { render } from "./DefaultLayout.vue?vue&type=template&id=0e1cd8da"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3957297443/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__